(() => {
    const WRAPPER = ".mana-cart-cross-sell-multiple-boxes";
    const CONTAINER = ".cross-sell-boxes";
    const ARROW_L = ".scroll-arrow.left";
    const ARROW_R = ".scroll-arrow.right";
    const SLIDE = ".mana-cart-cross-sell-box";
    const EPS = 2;
    const INTERVAL_MS = 2000;

    // Smooth scroll (variant 3)
    function smoothScrollTo(container, target) {
        if (!container) return;
        if (container.scrollLeft === target) return;

        container.scrollTo({
            left: target,
            behavior: "smooth"
        });
    }

    function initCrossSell(wrapper) {
        const container = wrapper.querySelector(CONTAINER);
        const left = wrapper.querySelector(ARROW_L);
        const right = wrapper.querySelector(ARROW_R);
        const pagination = wrapper.querySelector(".cross-sell-pagination");
        if (!container || !pagination) return;

        let autoplayId = null;
        let stoppedByUser = false;
        let currentIndex = 0;
        let isTransitioning = false;

        const slides = () => Array.from(container.querySelectorAll(SLIDE));

        // --- Pagination dots ---
        pagination.innerHTML = "";
        const dots = [];
        slides().forEach((_, idx) => {
            const dot = document.createElement("div");
            dot.className = "cross-sell-dot";
            if (idx === 0) dot.classList.add("active");
            dot.addEventListener("click", () => {
                stopAutoplay(true);
                goTo(idx);
            });
            pagination.appendChild(dot);
            dots.push(dot);
        });

        function updatePagination() {
            dots.forEach((dot, idx) => {
                dot.classList.toggle("active", idx === currentIndex);
            });
        }

        function updateArrows() {
            const s = slides();
            if (!left || !right || s.length <= 1) {
                if (left) left.style.display = "none";
                if (right) right.style.display = "none";
                return;
            }
            const max = container.scrollWidth - container.clientWidth;
            const sl = container.scrollLeft;
            left.style.display = sl > EPS ? "flex" : "none";
            right.style.display = sl < max - EPS ? "flex" : "none";
        }

        function goTo(i) {
            const s = slides();
            if (s.length < 2 || isTransitioning) {
                return;
            }

            isTransitioning = true;
            currentIndex = (i + s.length) % s.length;
            const targetOffset = s[currentIndex].offsetLeft;

            smoothScrollTo(container, targetOffset);
            updatePagination();

            setTimeout(() => {
                isTransitioning = false;
                updateArrows();
            }, 1000);
        }

        function next() {
            if (isTransitioning) {
                setTimeout(next, 300);
                return;
            }
            goTo(currentIndex + 1);
        }

        const prev = () => goTo(currentIndex - 1);

        function startAutoplay() {
            if (autoplayId || stoppedByUser) {
                return;
            }
            if (!container.clientWidth || slides().length < 2) {
                return;
            }

            autoplayId = setInterval(() => {
                if (!isTransitioning) {
                    next();
                }
            }, INTERVAL_MS);
        }

        function stopAutoplay(permanent = false) {
            if (autoplayId) {
                clearInterval(autoplayId);
                autoplayId = null;
            }
            if (permanent) stoppedByUser = true;
        }

        // Arrows
        if (left)
            left.addEventListener("click", (e) => {
                e.preventDefault();
                stopAutoplay(true);
                prev();
            });
        if (right)
            right.addEventListener("click", (e) => {
                e.preventDefault();
                stopAutoplay(true);
                next();
            });

        // User scroll → update pagination and stop autoplay
        let scrolld;
        container.addEventListener(
            "scroll",
            () => {
                updateArrows();
                const s = slides();
                if (s.length) {
                    const containerCenter = container.scrollLeft + container.clientWidth / 2;
                    let newIndex = currentIndex;
                    let closestDistance = Infinity;

                    s.forEach((slide, idx) => {
                        const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
                        const distance = Math.abs(containerCenter - slideCenter);
                        if (distance < closestDistance) {
                            closestDistance = distance;
                            newIndex = idx;
                        }
                    });

                    if (newIndex !== currentIndex) {
                        currentIndex = newIndex;
                        updatePagination();
                    }
                }

                if (isTransitioning) return;
                clearTimeout(scrolld);
                scrolld = setTimeout(() => stopAutoplay(true), 200);
            },
            { passive: true }
        );

        // Hover pause/resume
        container.addEventListener("mouseenter", () => {
            if (!stoppedByUser) stopAutoplay(false);
        });
        container.addEventListener("mouseleave", () => {
            if (!stoppedByUser) startAutoplay();
        });

        window.addEventListener("resize", updateArrows);

        // Drawer watcher
        const drawer = document.getElementById("CartDrawer");
        if (drawer) {
            const onDrawer = () => {
                if (drawer.classList.contains("js-drawer-open")) {
                    stoppedByUser = false;
                    currentIndex = 0;
                    updateArrows();
                    updatePagination();
                    startAutoplay();
                } else {
                    stopAutoplay(false);
                }
            };
            new MutationObserver(onDrawer).observe(drawer, {
                attributes: true,
                attributeFilter: ["class"]
            });
            onDrawer();
        } else {
            startAutoplay();
        }

        updateArrows();
        updatePagination();
    }

    // Init
    const boot = () => {
        const wrapper = document.querySelector(WRAPPER);
        if (wrapper && !wrapper.dataset.csInit) {
            wrapper.dataset.csInit = "1";
            initCrossSell(wrapper);
        }
    };
    new MutationObserver(boot).observe(document.body, {
        childList: true,
        subtree: true
    });
    boot();
})();